import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { postApi } from "../../services/api/api";
import "./Events.css";

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEventsList = async () => {
            try { 
                const response = await postApi("/event-list");
                const eventDataArray = response?.data;
                if (Array.isArray(eventDataArray)) {
                    setEvents(eventDataArray);
                } else { 
                    console.error("API response format unexpected:", response);
                    setEvents([]);
                }
            } catch (err) {
                console.error("Error fetching live events via ApiHelper:", err);
                setError(err.message || "Failed to load events. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchEventsList();
    }, []);

    return (
        <>
            <main className="main_wrapper">
                <div className="inn-ban">
                    <div className="container">
                        <div className="row">
                            <h1>Events by Vikas Mandal Mulund</h1>
                            <p>Creating memorable moments through cultural, social, and matrimonial events.</p>
                        </div>
                    </div>
                </div>

                <section className="events">
                    <div className="container">

                        {loading && (
                            <div className="text-center py-5">
                                <div className="spinner-border text-warning" role="status">
                                    <span className="visually-hidden">Loading events...</span>
                                </div>
                                <p className="text-muted mt-2">Fetching upcoming events, please wait...</p>
                            </div>
                            )}

                        {/* Error Handling State Feedback Row */}
                        {error && !loading && (
                            <div className="alert alert-danger text-center my-4" role="alert">
                                ⚠️ {error}
                            </div>
                            )}

                        {/* Empty Response State Fallback Viewport */}
                        {!loading && !error && events.length === 0 && (
                            <div className="text-center py-5 text-muted">
                                <p className="mb-0">No upcoming events are currently scheduled. Please check back later!</p>
                            </div>
                            )}

                        {/* Dynamic Events Card Loop Rendering */}
                        {!loading && !error && events.length > 0 && (
                            <div className="row d-flex">
                                {events.map((event, index) => {
                                    const imageSrc = event.image_url || "assets/imgs/event_default_img.png";
                                    const eventLocation = event.location || "Mumbai";
                                    const eventDate = event.start_date || "Upcoming";

                                    const displayLocation = eventLocation.length > 40
                                        ? `${eventLocation.substring(0, 37)}...`
                                        : eventLocation;

                                    return (
                                        <div className="col-md-4 mb-4" key={event.id || index}>
                                            {/* FIXED: URL is now explicitly and only '/EventDetails' */}
                                            <Link className="Event_container" to="/EventDetails" state={{ event }}>
                                                <img
                                                    src={imageSrc}
                                                    alt={event.title || "VMM Event Banner"}
                                                    loading="lazy"
                                                    onError={(e) => {
                                                        e.target.src = "assets/imgs/event_default_img.png";
                                                    }}
                                                />
                                                <div className="event_content">
                                                    <h4>{event.title || "Special Event"}</h4>
                                                    <p>{`${displayLocation}, ${eventDate.split(" ")[0]}`}</p>
                                                </div>
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>
                            )}
                    </div>
                </section>
            </main>
        </>
    );
};

export default Events;